export default __webpack_public_path__ + "static/media/logout.401ae098.svg";